import { Text } from '@billda/design-system';
import type { DateGroup } from '../../types/plotTimeline';

export interface TimeGroupHeaderProps {
  dateGroup: DateGroup;
}

/**
 * Date group header for timeline sections
 * Displays: "Today", "Yesterday", "This Week", or "Older"
 */
export function TimeGroupHeader({ dateGroup }: TimeGroupHeaderProps) {
  return (
    <Text
      variant="caption"
      color="secondary"
      className="mb-1 block font-semibold tracking-wide uppercase"
    >
      {dateGroup}
    </Text>
  );
}
